exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".div-inline{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-18f4ea8e!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/product/productModify.vue
// module id = 570
// module chunks = 2